import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";
import config from "appConfig";

const items = [
  {
    id: "94d896fe-1e9b-47ed-9a9e-7bfc8bab26c0",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/03/task/task-1-item-1.svg`,
      imageDescription: "Curtains",
    },
  },
  {
    id: "841e9c01-0c3e-4378-bdad-8e1b10f20af8",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/03/task/task-1-item-2.svg`,
      imageDescription: "Wooden half-cilinders",
    },
  },
  {
    id: "263aaa0b-defb-45ca-8eab-7eb5f843916b",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/03/task/task-1-item-3.svg`,
      imageDescription: "Porous foam panels",
    },
  },
  {
    id: "fe9dc71a-d42e-4390-8092-445b4327faf6",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/03/task/task-1-item-4.svg`,
      imageDescription: "Brick wall",
    },
  },
  {
    id: "f7bae85a-1a85-4f8b-9818-ced58349c709",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/03/task/task-1-item-5.svg`,
      imageDescription: "Wooden panels",
    },
  },
  {
    id: "d29f70ee-8334-4632-897c-8a461330f61a",
    options: {
      imageUrl: `${config.ASSETS_URL}/05/03/task/task-1-item-6.svg`,
      imageDescription: "Embossed ceiling",
    },
  },
];

const groups = [
  {
    id: "6e9cd8fd-4a93-4518-9be7-c1e74c0b86f3",
    content: "Sound reflecting surfaces",
    options: {},
  },
  {
    id: "cd6298be-b190-4687-be3e-cedd552ac181",
    content: "Sound absorbing surfaces",
    options: {},
  },
  {
    id: "462d4cad-8aee-4de8-a1d4-93f56a3e0bf5",
    content: "Sound scattering surfaces",
    options: {},
  },
];

export const task: Task = {
  id: "a2bf55fd-a58c-4c58-bcae-fe5fec989d25",
  solutionType: "group",
  type: "categorizeImages",
  options: {
    orientation: "horizontal",
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "6e9cd8fd-4a93-4518-9be7-c1e74c0b86f3",
      itemsId: ["fe9dc71a-d42e-4390-8092-445b4327faf6", "f7bae85a-1a85-4f8b-9818-ced58349c709"],
    },
    {
      groupId: "cd6298be-b190-4687-be3e-cedd552ac181",
      itemsId: ["94d896fe-1e9b-47ed-9a9e-7bfc8bab26c0", "263aaa0b-defb-45ca-8eab-7eb5f843916b"],
    },
    {
      groupId: "462d4cad-8aee-4de8-a1d4-93f56a3e0bf5",
      itemsId: ["841e9c01-0c3e-4378-bdad-8e1b10f20af8", "d29f70ee-8334-4632-897c-8a461330f61a"],
    },
  ],
};
